import React, { useState, useEffect } from 'react';
import './image-switcher.css';

const ImageSwitcher = ({ images, titleHu, titleEn, onClick, interval = 3000 }) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const id = setInterval(() => {
            setIndex(prev => (prev + 1) % images.length);
        }, interval);
        return () => clearInterval(id);
    }, [images.length, interval]);

    return (
        <div className="image-switcher-container" onClick={onClick}>
            <div className="ferris-title">{titleHu}</div>

            <div className="image-wrapper">
                {images.map((src, i) => (
                    <img
                        key={i}
                        src={src}
                        alt={`img-${i}`}
                        className={`fade-image ${i === index ? 'active' : ''}`}
                    />
                ))}
            </div>

            <div className="ferris-title">{titleEn}</div>
        </div>
    );
};

export default ImageSwitcher;
